import { Component, OnInit } from '@angular/core';
import { Cell } from '../../cell';
import { LayoutService } from '../../layout.service';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-cell-rich-text',
  templateUrl: './cell-rich-text.component.html',
  styleUrls: ['./cell-rich-text.component.less'],
})
export class CellRichTextComponent extends Cell {
  constructor(
    public layoutService: LayoutService,
    public drawerService: NzDrawerService
  ) {
    super(layoutService, drawerService);
  }

  ngOnInit(): void {}
}
